//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../lib/date';
import util from '../../lib/util';
import DeliveryRecords from './components/delivery-records';
import fileUploader from '../../views/common-components/file-uploader';

export default {
    name: 'deliveryPlanInfo',
    components: { DeliveryRecords, fileUploader },
    filters: {
        formatDate(time, type) {
            const date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        const vm = this;
        return {
            name: 'name1',
            loading: false,
            countDowning: false,
            saving: false,
            planId: 0,
            deliveryPlan: {},
            dranges: [],
            minutes: 5,
            seconds: 0,
            signUpLoading: false,
            showSignUpModal: false,
            signUpTimeDto: {},
            showDeliveryModal: false,
            deliveryDate: [],
            time: [],
            afternoonTime: [],
            savePlanDto: {},
            noticeActive: 'data-notice',
            columns: [
                // {
                //     type: 'selection',
                //     align: 'center',
                //     width: 60
                // },
                {
                    key: 'id', title: '单号', align: 'center', minWidth: 200,
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let code = row.deliveryCode;
                        if (code == null || code === '') {
                            code = '未填写';
                        }
                        actions.push(
                            h('a', {
                                on: {
                                    click: function () {
                                        vm.showDeliveryInfo(row);
                                    }
                                }
                            },
                                code
                            )
                        );
                        return actions;
                    }
                },
                // {
                //   title: '计划名称', minWidth: 99, key: 'planName', align: 'center',
                //   render: (h, params) => {
                //     let row = params.row;
                //     let actions = [];
                //     actions.push(
                //         h('a', {
                //           on: {
                //             click: function () {
                //               vm.$router.push({
                //                 name: 'deliveryPlanInfo',
                //                 params: {
                //                   planId: row.planId
                //                 }
                //               });
                //             }
                //           }
                //         }, row.planName));
                //     return actions;
                //   }
                // },
                {
                    title: '预约时间', minWidth: 110, key: '', align: 'center',
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let str = '';
                        if (row.deliveryTimeStr) {
                            str = str + row.deliveryTimeStr;
                        }
                        if (row.time) {
                            str = str + ' ' + row.time;
                        }
                        // let str = row.deliveryTimeStr ? row.deliveryTimeStr : '';
                        // str = str + row.time ? row.time : '';
                        // const d = actions.push(h('p', str));
                        return h('span', str);
                    }
                },
                {
                    title: '项目名称', align: 'center', key: 'projectName', minWidth: 250,
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        actions.push(h('p', row.projectName));
                        actions.push(h('p', row.roomName));
                        return h('div', actions);
                    }
                },
                // {
                //     title: '房间', align: 'center', key: 'roomName', minWidth: 250
                // },
                {
                    key: 'name', align: 'center', title: '联系信息', minWidth: 200,
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        actions.push(h('p', '联系人：' + row.name));
                        actions.push(h('p', '联系电话：' + row.mobile));
                        return h('div', actions);
                    }
                },
                {
                    key: 'content', align: 'center', title: '预约说明', width: 200,
                    render(h, params) {
                        let content = '';
                        let row = params.row;
                        if (row.content != null && row.content !== '') {
                            if (row.content.length > 20) {
                                content = row.content.substring(1, 20) + '...';
                            } else {
                                content = row.content;
                            }
                        }
                        return h('Poptip', {
                            props: {
                                trigger: 'hover',
                                // title:' 11',
                                placement: 'bottom'
                            }
                        }, [
                            h('div', content),
                            h('div', {
                                slot: 'content',
                                style: {
                                    // width: "300px",
                                    // height: "100px",
                                    overflow: 'hidden',
                                    whiteSpace: 'normal'
                                }
                            }, [
                                h('div', row.content)
                            ])
                        ]);
                    }
                },
                {
                    title: '资料状态', align: 'center', minWidth: 99, key: 'dataStatusStr'
                },
                {
                    title: '预约状态', minWidth: 99, align: 'center', key: 'appointmentStatusStr'
                },
                {
                    title: '房屋交付文件确认', minWidth: 150, align: 'center', key: 'isReceiveSignature',
                    render: (h, { row }) => {
                        return h('span', row.isReceiveSignature ? "已签名" : "未签名")
                    }
                },
                {
                    title: '房屋交付文件签名时间', minWidth: 150, align: 'center', key: 'receiveSignatureTime',
                    render: (h, { row }) => {
                        return h('span', row.receiveSignatureTime ? vm.formatDate(row.receiveSignatureTime) : "")
                    }
                }
                // {
                //     title: '交房状态', minWidth: 99, align: 'center', key: 'deliveryStatusStr'
                // }
                // {
                //     key: 'statusStr', align: 'center', minWidth: 99,
                //     title: '状态'
                // }
                // {
                //     title: '操作',
                //     key: '',
                //     render: (h, params) => {
                //         let row = params.row;
                //         let actions = [];
                //         if (row.status == 11) {
                //             actions.push(h('Button', {
                //                 props: {
                //                     type: 'primary',
                //                     size: 'small'
                //                 },
                //                 style: {
                //                     // marginRight: '5px'
                //                 },
                //                 on: {
                //                     click: () => {
                //                          vm.dataAudit(params.row);
                //                     }
                //                 }
                //             }, '资料审核'));
                //         }
                //         return h('div', actions);
                //     }
                // }
            ],
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchInput: {},
            list: [],
            showUrlModal: false,
            // microUrl: util.BaseUrl + '#/delivery/'
        };
    },
    methods: {
        tabClicked(name) {
            this.name = name;
        },
        onRefreshNotice(type) {
            if (type === 'deliver-notice') {
                this.$refs.deliverNoticeRef.pageChange(1);
            } else if (type === 'data-notice') {
                this.$refs.dataNoticeRef.pageChange(1);
            } else {
                this.$refs.deliverNoticeRef.pageChange(1);
                this.$refs.dataNoticeRef.pageChange(1);
            }
        },
        getDeliveryPlanById() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Delivery/GetDeliveryPlanById?id=' + this.planId).then(res => {
                // this.deliveryPlan = {};
                // // this.$refs.deliveryPlanForm.resetFields();
                this.deliveryPlan = JSON.parse(JSON.stringify(res.data.result));
                this.dranges = [];
                this.dranges = JSON.parse(this.deliveryPlan.deliveryRange);

                //
                this.savePlanDto = {};
                this.savePlanDto = JSON.parse(JSON.stringify(res.data.result));

                this.signUpTimeDto = {};
                this.signUpTimeDto = {
                    id: this.savePlanDto.id,
                    signUpEndTime: this.savePlanDto.signUpEndTime,
                    signUpStartTime: this.savePlanDto.signUpStartTime
                };

                this.deliveryDate = [];
                this.time = [];
                this.deliveryDate.push(this.savePlanDto.deliveryStartTimeStr);
                this.deliveryDate.push(this.savePlanDto.deliveryEndTimeStr);
                if (this.savePlanDto.startTime == null) {
                    this.savePlanDto.startTime = '';
                }
                if (this.savePlanDto.endTime == null) {
                    this.savePlanDto.endTime = '';
                }
                this.time.push(this.savePlanDto.startTime);
                this.time.push(this.savePlanDto.endTime);
                this.afternoonTime = [];
                if (this.savePlanDto.afternoonStartTime && this.savePlanDto.afternoonStartTime) {
                    this.afternoonTime.push(this.savePlanDto.afternoonStartTime);
                    this.afternoonTime.push(this.savePlanDto.afternoonEndTime);
                }
                this.deliveryPlan.steps = this.deliveryPlan.steps.map(z => z.step);

            }).finally(() => {
                this.loading = false;
            });
        },
        approve() {
            var vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认审核吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Delivery/Approve?id=' + this.planId).then(() => {
                        // this.showDeliveryPlanEditModal = false;
                        this.getDeliveryPlanById();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        cancelAudit() {
            var vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认取消审核吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Delivery/CancelAudit?id=' + this.planId).then(() => {
                        // this.showDeliveryPlanEditModal = false;
                        this.getDeliveryPlanById();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        delDeliveryPlan() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + this.deliveryPlan.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    abp.ajax.delete('/api/services/app/Delivery/Delete?id=' + this.planId).then(() => {
                        // this.showDeliveryPlanEditModal = false;
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        this.$router.push({ name: 'deliveryPlans' });
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        editDeliverPlan() {
            this.$router.push({
                name: 'deliveryPlanEdit',
                params: {
                    planId: this.planId
                }
            });
        },
        //提交资料阶段
        signUpNotice() {
            //交付预约-报名阶段
            // const vm = this;
            // this.$Modal.confirm({
            //     title: this.L('Tips'),
            //     content: '确认进入提交交付材料阶段',
            //     okText: this.L('Yes'),
            //     cancelText: this.L('No'),
            //     onOk: async () => {
            //
            //     }
            // });
            this.showSignUpModal = true;
        },
        onSaveSignUpTime() {
            if (!this.signUpTimeDto.signUpStartTime) {
                abp.message.error('请输入提交资料开始时间');
                return;
            }
            if (!this.signUpTimeDto.signUpEndTime) {
                abp.message.error('请输入提交资料结束时间');
                return;
            }
            this.saving = true;
            this.signUpTimeDto.id = this.planId;
            abp.ajax.post('/api/services/app/Delivery/SaveSignUpTime', this.signUpTimeDto).then(res => {
                this.showSignUpModal = false;
                this.getDeliveryPlanById();
                this.saveRecordSignUpStageByPlan();

            }).finally(() => {
                this.saving = false;
                // this.countDowning = false;
            });
        },
        saveRecordSignUpStageByPlan() {
            this.signUpLoading = true;
            abp.ajax.post('/api/services/app/Delivery/SaveRecordSignUpStageByPlan?planId=' + this.planId).then(res => {
                this.onRefreshNotice();
            }).finally(() => {
                this.signUpLoading = false;
            });
        },
        num: function (n) {
            return n < 10 ? '0' + n : '' + n;
        },
        add: function () {
            var _this = this;
            var time = window.setInterval(function () {
                if (_this.seconds === 0 && _this.minutes !== 0) {
                    _this.seconds = 59;
                    _this.minutes -= 1;
                } else if (_this.minutes === 0 && _this.seconds === 0) {
                    _this.seconds = 0;
                    this.countDowning = false;
                    window.clearInterval(time);
                } else {
                    _this.seconds -= 1;
                }
            }, 1000);
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },
        onClicked() {
            let url = util.ApiUrl + 'file/DownloadPdfData?planId=' + this.planId;
            window.open(url);
        },
        onClickedDeliveryReceivePdfData() {
            let url = util.ApiUrl + 'file/DownloadDeliveryReceivePdfData?planId=' + this.planId;
            window.open(url);
        },
        onClickedDownloadExcel() {
            if (!this.planId) {
                this.$Message.error('请选择一个计划');
                return;
            }
            let url = util.ApiUrl + 'delivery/deliveryRecordExcel?planId=' + this.planId + '&status=' + this.tabName;
            window.open(url);
        },
        signUpStartTimeChange(date) {
            this.signUpTimeDto.signUpStartTime = date;
        },
        signUpEndTimeChange(date) {
            this.signUpTimeDto.signUpEndTime = date;
        },
        deliveryDateChange(date) {
            // console.log(date);
            this.savePlanDto.deliveryStartTime = date[0];
            this.savePlanDto.deliveryEndTime = date[1];
        },
        timeChange(time) {
            // console.log(time);
            this.savePlanDto.startTime = time[0];
            this.savePlanDto.endTime = time[1];
        },
        afternoonTimeChange(time) {
            this.savePlanDto.afternoonStartTime = time[0];
            this.savePlanDto.afternoonEndTime = time[1];
        },
        deliveryStartTimeChange(date) {
            this.savePlanDto.deliveryStartTime = date;
        },
        deliveryEndTimeChange(date) {
            this.savePlanDto.deliveryEndTime = date;
        },
        appointmentStartTimeChange(date) {
            this.savePlanDto.appointmentStartTime = date;
        },
        appointmentEndTimeChange(date) {
            this.savePlanDto.appointmentEndTime = date;
        },
        onShowDeliveryModal() {
            this.showDeliveryModal = true;
        },
        onSavePlan() {
            let vm = this;
            // if (!this.savePlanDto.dailyNumber > 0) {
            //     abp.message.warn('每天交付人数不能为0');
            //     return;
            // }
            // if (!this.savePlanDto.hourlyNumber > 0) {
            //     abp.message.warn('每时段人数不能为0');
            //     return;
            // }
            if (!this.savePlanDto.deliveryStartTime) {
                abp.message.warn('请选择交付日期');
                return;
            }
            if (!this.savePlanDto.deliveryEndTime) {
                abp.message.warn('请选择交付日期');
                return;
            }
            if (!this.savePlanDto.startTime) {
                abp.message.warn('请选择交付时段');
                return;
            }
            if (!this.savePlanDto.endTime) {
                abp.message.warn('请选择交付时段');
                return;
            }
            if (!this.savePlanDto.appointmentStartTime) {
                abp.message.warn('请选择开发预约开始时间');
                return;
            }
            if (!this.savePlanDto.appointmentEndTime) {
                abp.message.warn('请选择开发预约结束时间');
                return;
            }
            this.saving = true;
            abp.ajax.post('/api/services/app/Delivery/SaveDeliveryData', this.savePlanDto).then(res => {
                // this.showDeliveryPlanEditModal = false;
                // this.onRefreshNotice();
                this.showDeliveryModal = false;
                this.getDeliveryPlanById();
                this.saveRecords(vm.savePlanDto.isALlRecord);
            }).finally(() => {
                this.saving = false;
            });
        },
        saveRecords(isALlRecord) {

            var isAll;
            if (isALlRecord) {
                isAll = true;
            } else {
                isAll = false;
            }

            this.countDowning = true;
            abp.ajax.post('/api/services/app/Delivery/SaveRecordByPlan?planId=' + this.planId + '&isAll=' + isAll).then(res => {
                this.onRefreshNotice();
            }).finally(() => {
                this.countDowning = false;
            });
        },

        onNoticeTabsClicked(value) {
            this.noticeActive = value;
        },

        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.searchInput.planId = this.planId;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            abp.ajax.post('/api/services/app/DeliveryRecord/SearchDeliveryRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
                // this.getCounts();
            }).finally(() => {
                this.loading = false;
            });
        },

        showDeliveryInfo(row) {
            this.$router.push({
                path: '/reservationInfo/' + row.id
            });
        },

        onSendDeliveryByPlanId() {
            this.saving = true
            abp.ajax.post('/api/services/app/Delivery/SendDeliveryByPlanId?planId=' + this.planId, {}, { timeout: 1000 * 30 * 6 }).then(res => {

            }).finally(() => {
                this.saving = false
            })
        },
        formatDate(time, type) {
            const date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }

    },
    computed: {
        second: function () {
            return this.num(this.seconds);
        },
        minute: function () {
            return this.num(this.minutes);
        },
        microUrl() {
            return util.MicroUrl + '#/delivery/' + this.planId
        }
    },
    mounted() {
        // this.add();
    },
    created() {
        this.planId = parseInt(this.$route.params.planId) || 0;
        if (this.planId > 0) {
            this.getDeliveryPlanById();
            this.getPage();
        }
    },
    watch: {
        second: {
            handler(newVal) {
                this.num(newVal);
            }
        },
        minute: {
            handler(newVal) {
                this.num(newVal);
            }
        }
    }
};
